export default __webpack_public_path__ + "static/media/double-deck-02.b546831f.svg";